import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

interface MaintenanceProps {
  title?: string;
  description?: string;
}

const Maintenance = ({ title, description }: MaintenanceProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.maintenance_container}>
      <div className={styles.content}>
        <img
          className={styles.icon}
          src="/assets/images/svg/settings.svg"
          alt={t("lbl_maintenance_title")}
        />
        <h3 className={styles.title}>{title ?? t("lbl_maintenance_title")}</h3>
        <p className={styles.description}>
          {description ?? t("lbl_maintenance_description")}
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
